import {LegalDisclaimer} from '@smart/web-components';
import * as React from 'react';

export const LegalDisclaimers = React.memo(LegalDisclaimer);
